import React from 'react';
import { Routes, Route, useParams } from 'react-router-dom';
import VideoPlayer from './VideoPlayer';
import AdminPanel from './AdminPanel';
import PlaylistPage from './PlaylistPage';
import './App.css';

function App() {
  return (
    <Routes>
      <Route path="/" element={<AdminPanel />} />
      <Route path="/admin" element={<AdminPanel />} />
      <Route path="/watch/:videoId" element={<VideoPage />} />
      <Route path="/embed/:videoId" element={<VideoPage />} />
      <Route path="/playlist/:playlistId" element={<PlaylistPage />} />
    </Routes>
  );
}

function VideoPage() {
  const { videoId } = useParams();
  return <VideoPlayer videoId={videoId} />;
}

export default App;
